import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import data from "../Data.json";
import getSymbolFromCurrency from 'currency-symbol-map';

const ProfilePage = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [orders, setOrders] = useState([]);
  const [activeTab, setActiveTab] = useState("profile");
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");

  console.log(orders);


  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      const fullNameParts = decodedToken.first_name
        ? [decodedToken.first_name, decodedToken.last_name]
        : decodedToken.fullName?.split(" ") || ["", ""];

      setUserInfo({
        fullName: `${decodedToken.first_name || fullNameParts[0]} ${decodedToken.last_name || fullNameParts[1] || ""
          }`,
        firstName: decodedToken.first_name || fullNameParts[0] || "",
        lastName: decodedToken.last_name || fullNameParts[1] || "",
        email: decodedToken.email,
        phone: decodedToken.phone || "",
        userId: decodedToken.id, // Assuming the token contains user ID
      });

      setFormData({
        firstName: decodedToken.first_name || fullNameParts[0] || "",
        lastName: decodedToken.last_name || fullNameParts[1] || "",
        email: decodedToken.email,
        phone: decodedToken.phone || "",
      });

      // Fetch user orders
      fetchUserOrders(decodedToken.id);
    }
  }, []);

  const fetchUserOrders = async (userId) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/orders/users/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.orders && response.data.orders.length > 0) {
        // Transform the order data to match the existing structure
        const transformedOrders = response.data.orders.map((order) => ({
          orderId: order.order_id,
          totalPrice: parseFloat(order.total_price),
          currency_code: order.currency_code,
          status: order.status,
          orderDate: new Date(order.order_date),
          email: order.email,
          fullName: order.full_name,
          phone: order.phone,
          country: order.country,
          postalCode: order.postal_code,
          state: order.state,
          city: order.city,
          street: order.street,
          items: order.products.map((product) => ({
            name: product.product_name,
            price: `${product.price.toFixed(2)}`,
            currency_code: product.currency_code,
            quantity: product.quantity,
            image:
              `${process.env.REACT_APP_API_URI}/uploads/${product.image}` ||
              data.products[0].image, // Placeholder image
            description: product.description,
            size: product.units?.size || "N/A",
          })),
        }));

        setOrders(transformedOrders);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      // toast.error(error.response?.data?.message || "Failed to fetch orders");
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("orders");
    toast.success("Logged out successfully!");
    setTimeout(() => {
      window.location.href = "/";
    }, 1000);
  };

  const handleCancelOrder = async (orderId) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URI}/orders/cancel/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
        }
      );

      const updatedOrders = orders.filter((order) => order.orderId !== orderId);
      setOrders(updatedOrders);
      toast.success(`Order #${orderId} canceled successfully`);
    } catch (error) {
      console.error("Failed to cancel order:", error);
      toast.error(error.response?.data?.message || "Failed to cancel order");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return false;
    }

    // Phone validation (basic)
    const phoneRegex = /^\d{10,15}$/;
    if (
      formData.phone &&
      !phoneRegex.test(formData.phone.replace(/[-()\s]/g, ""))
    ) {
      toast.error("Please enter a valid phone number");
      return false;
    }

    return true;
  };


  const handleUpdateProfile = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    try {
      // Prepare request body with the correct field names that match your API
      const updateData = {
        first_name: formData.firstName, // Match the API field names
        last_name: formData.lastName,
        email: formData.email,
        phone: formData.phone,
      };


      const response = await axios.put(
        `http://localhost:4000/auth/updatePersonDetails/${userInfo.userId}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Profile update response:", response.data); // Debug the response

      if (response.data) {
        // Check if token exists in the response
        if (response.data.token) {
          // Update the token in session storage
          sessionStorage.setItem("token", response.data.token);

          // setToken(response.data.token); // Uncomment if you have a token state
        } else {
          console.warn("No token received in the update response");
        }

        // Update local user info with the user data from response if available
        if (response.data.user) {
          setUserInfo({
            ...userInfo,
            fullName: `${response.data.user.first_name} ${response.data.user.last_name}`,
            firstName: response.data.user.first_name,
            lastName: response.data.user.last_name,
            email: response.data.user.email,
            phone: response.data.user.phone,
          });
        } else {
          // Fall back to form data if response doesn't include user info
          setUserInfo({
            ...userInfo,
            fullName: `${formData.firstName} ${formData.lastName}`,
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            phone: formData.phone,
          });
        }

        toast.success("Profile updated successfully!");
        setIsEditing(false);
      }
    } catch (error) {
      console.error("Error updating profile:", error);

      // More detailed error logging
      if (error.response) {
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
      }

      toast.error(error.response?.data?.message || "Failed to update profile");
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleEditMode = () => {
    if (isEditing) {
      // Reset form data to current user info if canceling edit
      setFormData({
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        email: userInfo.email,
        phone: userInfo.phone || "",
      });
    }
    setIsEditing(!isEditing);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] pt-10">
      <div className="max-w-[1400px] mx-auto p-8 pt-[7rem]">
        <div className="bg-white rounded-[20px] p-8 shadow-lg mb-8">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="relative">
              <div className="w-32 h-32 rounded-full bg-gradient-to-r from-[#ECF3FE] to-[#FDFEFF] border-4 border-white shadow-xl flex items-center justify-center">
                <span className="text-4xl font-semibold text-[#f36812]">
                  {userInfo?.firstName?.charAt(0) || "A"}
                </span>
              </div>
              <button
                onClick={toggleEditMode}
                className="absolute bottom-0 right-0 w-10 h-10 bg-[#000] rounded-full shadow-lg flex items-center justify-center hover:bg-[#f36812] transition-all duration-300"
              >
                <svg
                  className="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {isEditing ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                    />
                  )}
                </svg>
              </button>
            </div>
            <div className="text-center md:text-left">
              <h1 className="text-3xl font-semibold text-[#1E293B] mb-2">
                {userInfo?.fullName || "Welcome Back!"}
              </h1>
              <p className="text-[#64748B]">{userInfo?.email}</p>
            </div>
            {sessionStorage.getItem("token") && (
              <button
                onClick={handleLogout}
                className="px-6 py-2 bg-orange-500 text-white rounded-full font-medium hover:bg-orange-600 transition-all duration-300 flex items-center gap-2 ml-auto"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
                Logout
              </button>
            )}
          </div>
          <div className="flex justify-center md:justify-start gap-6 mt-8">
            {["profile", "orders"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`relative px-6 py-3 text-lg font-medium transition-all duration-300 ${activeTab === tab
                  ? "text-[#f36812]"
                  : "text-[#64748B] hover:text-[#f36812]"
                  }`}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
                {activeTab === tab && (
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#f36812] rounded-full" />
                )}
                {tab === "orders" && orders.length > 0 && (
                  <span className="absolute -top-2 -right-2 bg-[#f36812] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {orders.length}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-[20px] p-8 shadow-lg">
          {activeTab === "profile" ? (
            <div className="space-y-8">
              <div className="flex justify-between items-center">
                <h2 className="text-2xl font-semibold text-[#1E293B] mb-6">
                  Personal Information
                </h2>
                {!isEditing && (
                  <button
                    onClick={toggleEditMode}
                    className="px-6 py-2 bg-[#f36812] text-white rounded-full font-medium hover:bg-[#e55a00] transition-all duration-300 flex items-center gap-2"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                      />
                    </svg>
                    Edit Profile
                  </button>
                )}
              </div>

              {userInfo ? (
                isEditing ? (
                  <form onSubmit={handleUpdateProfile} className="space-y-6">
                    <div className="grid grid-cols-1 gap-8">
                      <div className="bg-[#F8FAFC] rounded-[20px] p-6 hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center gap-4 mb-6">
                          <div className="w-12 h-12 rounded-full bg-[#EFF6FF] flex items-center justify-center">
                            <svg
                              className="w-6 h-6 text-[#f36812]"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                              />
                            </svg>
                          </div>
                          <div>
                            <h3 className="text-xl font-semibold text-[#1E293B]">
                              Contact Details
                            </h3>
                            <p className="text-[#64748B] text-sm">
                              Update your personal information
                            </p>
                          </div>
                        </div>
                        <div className="space-y-4">
                          <InputField
                            label="First Name"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            required
                          />
                          <InputField
                            label="Last Name"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            required
                          />
                          <InputField
                            label="Email"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                          <InputField
                            label="Phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                    </div>

                    <div className="flex justify-end gap-4 pt-4">
                      <button
                        type="button"
                        onClick={toggleEditMode}
                        className="px-6 py-2 bg-gray-300 text-gray-700 rounded-full font-medium hover:bg-gray-400 transition-all duration-300"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="px-6 py-2 bg-[#f36812] text-white rounded-full font-medium hover:bg-[#e55a00] transition-all duration-300 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {isSubmitting ? (
                          <>
                            <svg
                              className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Updating...
                          </>
                        ) : (
                          <>
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            Save Changes
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                ) : (
                  <div className="grid grid-cols-1 gap-8">
                    <div className="bg-[#F8FAFC] rounded-[20px] p-6 hover:shadow-lg transition-all duration-300">
                      <div className="flex items-center gap-4 mb-6">
                        <div className="w-12 h-12 rounded-full bg-[#EFF6FF] flex items-center justify-center">
                          <svg
                            className="w-6 h-6 text-[#f36812]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-xl font-semibold text-[#1E293B]">
                            Contact Details
                          </h3>
                          <p className="text-[#64748B] text-sm">
                            Your personal information
                          </p>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <InfoRow
                          label="First Name"
                          value={userInfo.firstName}
                        />
                        <InfoRow label="Last Name" value={userInfo.lastName} />
                        <InfoRow label="Email" value={userInfo.email} />
                        <InfoRow
                          label="Phone"
                          value={userInfo.phone || "Not provided"}
                        />
                      </div>
                    </div>
                    {/* <div className="bg-[#F8FAFC] rounded-[20px] p-6 hover:shadow-lg transition-all duration-300">
                      <div className="flex items-center gap-4 mb-6">
                        <div className="w-12 h-12 rounded-full bg-[#EFF6FF] flex items-center justify-center">
                          <svg
                            className="w-6 h-6 text-[#f36812]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-xl font-semibold text-[#1E293B]">
                            Shipping Address
                          </h3>
                          <p className="text-[#64748B] text-sm">
                            Your delivery information
                          </p>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <InfoRow
                          label="Country"
                          value={userInfo.country || "N/A"}
                        />
                        <InfoRow label="City" value={userInfo.city || "N/A"} />
                        <InfoRow
                          label="State"
                          value={userInfo.state || "N/A"}
                        />
                        <InfoRow
                          label="ZIP Code"
                          value={userInfo.zip || "N/A"}
                        />
                      </div>
                    </div> */}
                  </div>
                )
              ) : (
                <EmptyState message="No user information available" />
              )}
            </div>
          ) : (
            <div className="space-y-8 overflow-y-auto max-h-[60vh]">
              <h2 className="text-2xl font-semibold text-[#1E293B] mb-6">
                Order History
              </h2>
              {isLoading ? (
                <LoadingState />
              ) : orders.length > 0 ? (
                <div className="space-y-6">
                  {orders.map((order) => (
                    <div
                      key={order.orderId}
                      className="bg-[#F8FAFC] rounded-[20px] p-6 hover:shadow-lg transition-all duration-300"
                    >
                      {/* Order Header */}
                      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 rounded-full bg-[#EFF6FF] flex items-center justify-center">
                            <svg
                              className="w-6 h-6 text-[#f36812]"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                              />
                            </svg>
                          </div>
                          <div>
                            <h3 className="text-xl font-semibold text-[#1E293B]">
                              Order #{order.orderId}
                            </h3>
                            <p className="text-[#64748B] text-sm">
                              Placed on{" "}
                              {order.orderDate.toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              })}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-4">
                          <span
                            className={`px-4 py-1 rounded-full text-sm font-medium ${order.status === "Pending"
                              ? "bg-yellow-500 text-white"
                              : order.status === "Processing"
                                ? "bg-blue-500 text-white"
                                : "bg-green-500 text-white"
                              }`}
                          >
                            {order.status}
                          </span>
                          <span className="text-xl font-semibold text-[#1E293B]">
                            {getSymbolFromCurrency(order.currency_code)}{" "}
                            {order.totalPrice.toFixed(2)}
                          </span>
                        </div>
                      </div>

                      {/* Items Section */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                        {order.items.map((item, idx) => (
                          <div
                            key={idx}
                            className="flex items-center gap-4 bg-white rounded-xl p-4"
                          >
                            <img
                              src={item.image}
                              alt={item.name}
                              className="w-20 h-20 object-cover rounded-xl"
                            />
                            <div>
                              <h4 className="font-medium text-[#1E293B] mb-1">{item.name}</h4>
                              <p className="text-sm text-gray-500 mt-1">
                                <span className="font-medium text-gray-700">Militer:</span>{" "}
                                {item.size}
                              </p>
                              <p className="text-[#64748B]">
                                {getSymbolFromCurrency(item.currency_code)} {item.price} x{" "}
                                {item.quantity}
                              </p>
                              <p className="text-[#64748B] text-sm">{item.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Shipping Address Section */}
                      <div className="bg-[#F8FAFC] rounded-[20px] p-6 hover:shadow-lg transition-all duration-300 mb-6">
                        <div className="flex items-center gap-4 mb-6">
                          <div className="w-12 h-12 rounded-full bg-[#EFF6FF] flex items-center justify-center">
                            <svg
                              className="w-6 h-6 text-[#f36812]"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                              />
                            </svg>
                          </div>
                          <div>
                            <h3 className="text-xl font-semibold text-[#1E293B]">
                              Shipping Address
                            </h3>
                            <p className="text-[#64748B] text-sm">Your delivery information</p>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <InfoRow label="Full Name" value={order.full_name || "N/A"} />
                          <InfoRow label="Email" value={order.email || "N/A"} />
                          <InfoRow label="Phone" value={order.phone || "N/A"} />
                          <InfoRow label="Country" value={order.country || "N/A"} />
                          <InfoRow label="City" value={order.city || "N/A"} />
                          <InfoRow label="State" value={order.state || "N/A"} />
                          <InfoRow label="Postal Code" value={order.postalCode || "N/A"} />
                          <InfoRow label="Street" value={order.street || "N/A"} />
                        </div>
                      </div>

                      {/* Cancel Button */}
                      <div className="flex justify-end">
                        <button
                          onClick={() => handleCancelOrder(order.orderId)}
                          className="px-6 py-2 bg-red-500 text-white rounded-full font-medium hover:bg-red-600 transition-all duration-300"
                        >
                          Cancel Order
                        </button>
                      </div>
                    </div>
                  ))}
                </div>


              ) : (
                <EmptyState message="No orders found" />
              )}
            </div>
          )}
        </div>
      </div>
      <Toaster />
    </div >
  );
};

const InfoRow = ({ label, value }) => (
  <div className="flex justify-between items-center py-2 border-b border-[#E2E8F0] last:border-0 flex-wrap">
    <span className="text-[#64748B]">{label}</span>
    <span className="font-medium text-[#1E293B] break-words">{value}</span>
  </div>
);

const InputField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  required = false,
  placeholder = "",
}) => (
  <div className="flex flex-col py-2 border-b border-[#E2E8F0] last:border-0">
    <label htmlFor={name} className="text-[#64748B] mb-1">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      placeholder={placeholder}
      className="font-medium text-[#1E293B] bg-transparent border-0 focus:ring-0 focus:outline-none p-1"
    />
  </div>
);

const EmptyState = ({ message }) => (
  <div className="text-center py-12">
    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#EFF6FF] flex items-center justify-center">
      <svg
        className="w-8 h-8 text-[#f36812]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <p className="text-[#64748B]">{message}</p>
  </div>
);

const LoadingState = () => (
  <div className="text-center py-12">
    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#EFF6FF] flex items-center justify-center animate-pulse">
      <svg
        className="w-8 h-8 text-[#f36812]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </div>
    <p className="text-[#64748B] animate-pulse">Loading orders...</p>
  </div>
);

export default ProfilePage;
